/* eslint-disable camelcase */

import ReactComponentRegistry from 'react_component_registry';
import { PrevPayrollProviderValues } from 'packages/signup/components/SurveyQuestions';
import type { TofuSurveyQuestionsType } from 'packages/signup/components/TofuSurvey';
import type {
  CompanyLead,
  CompanyLeadPayload,
  FormDetailsValues,
  LeadOriginData,
  SubmissionOrigin,
} from './types';
import estimatePasswordStrength from '../../../../helpers/estimate_password_strength';

const getHasPaidW2 = (surveyAnswers: TofuSurveyQuestionsType) => {
  if (surveyAnswers.prevPayrollProvider === PrevPayrollProviderValues.NEW) {
    return 'No, we haven’t paid anyone';
  }

  if (
    surveyAnswers.prevPayrollProvider === PrevPayrollProviderValues.OTHER ||
    surveyAnswers.prevPayrollProvider === PrevPayrollProviderValues.MANUALLY
  ) {
    return 'Yes, we have';
  }

  return 'I don’t know';
};

const getPreviousPayrollProvider = (surveyAnswers: TofuSurveyQuestionsType) => {
  if (surveyAnswers.prevPayrollProvider === PrevPayrollProviderValues.NEW) {
    return 'I don’t know';
  }
  return surveyAnswers.prevPayrollProvider;
};

const getSubmitPayload = (
  values: FormDetailsValues,
  surveyAnswers: TofuSurveyQuestionsType,
  leadSource: string,
  tierSource: string,
  tier: string,
  lead: CompanyLead,
  submissionOrigin: SubmissionOrigin,
  leadOriginData: LeadOriginData = {}
) => {
  const companyLead = {
    company_name: values.companyName || '',
    email: values.email || '',
    first_name: values.firstName || '',
    last_name: values.lastName || '',
    number_employees: values.numberEmployees || '',
    phone: values.phone || '',
    submitted_from: lead?.submitted_from,
    source: leadSource,
    password_strength_score: estimatePasswordStrength(values.password).score,
    sold_by: lead?.sold_by || '',
    sold_by_accountant_id: lead?.sold_by_accountant_id || '',
    campaign: lead?.campaign || '',
    tier,
    hi_interest: '',
    lead_origin: leadOriginData?.leadOrigin,
    lead_origin_subtype: leadOriginData?.leadOriginSubtype,
  } as CompanyLeadPayload;

  const discoverySurvey = {
    has_paid_w2: getHasPaidW2(surveyAnswers),
    ran_historical_payroll_on_signup_year: surveyAnswers.runPayroll,
    previous_payroll_provider: getPreviousPayrollProvider(surveyAnswers),
    industry_identification: surveyAnswers.industryIdentification || '',
  };

  const user = {
    password: values.password,
    password_confirmation: values.passwordConfirmation,
  };

  return {
    authenticity_token: ReactComponentRegistry.authenticityToken(),
    company_lead: companyLead,
    discovery_survey: discoverySurvey,
    user,
    tier_source: tierSource,
    submission_origin: submissionOrigin,
  };
};

export default getSubmitPayload;
